import { Component, Output, EventEmitter, OnInit, inject } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { AdminService } from '../../admin.service';
import { saveAs } from '@progress/kendo-file-saver';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-download-log-files',
  templateUrl: './download-log-files.component.html',
  styleUrls: ['../toolbox.component.scss'],
  imports: [MatSelectModule, FormsModule, MatButtonModule],
})
export class DownloadLogFilesComponent implements OnInit {
  private admnSrvc = inject(AdminService);

  @Output() toggleLoading = new EventEmitter();
  availableSolutions = [];
  solutionName: string;
  downloadRecentSLF = {
    id: null,
    app: null,
    status: null,
    statusClass: null,
  };

  ngOnInit(): void {
    this.getSolutions();
  }

  getSolutions() {
    this.toggleLoading.emit();
    this.admnSrvc.getSolutionLogFiles().subscribe(res => {
      if (res) {
        res.solutions.forEach(solution => {
          this.availableSolutions.push(Object.keys(solution)[0]);
        });
        this.toggleLoading.emit();
      }
    });
  }

  getSLF() {
    this.toggleLoading.emit();

    this.admnSrvc.downloadRecentSLF(this.solutionName).subscribe({
      next: res => {
        this.toggleLoading.emit();
        let fileData;
        const filename = `${this.solutionName.toUpperCase()}-SolutionLogFiles.txt`;
        const reader = new FileReader();
        reader.readAsDataURL(res);

        reader.onloadend = () => {
          fileData = reader.result;
          saveAs(fileData, filename);
        };
      },
      error: err => {
        this.toggleLoading.emit();
        this.downloadRecentSLF.status = err;
        this.downloadRecentSLF.statusClass = 'failure';
        return throwError(() => err.error || 'Server error');
      },
    });
  }
}
